import React, { useState, useCallback } from 'react';
import { default as SayfaKullaniciDogrula } from './sayfa-kullanici-dogrula';
import { default as SayfaSonuc } from './sayfa-sonuc';
import { Alert } from "../../components";


const SAYFA_KULLANICI  = 1;
const SAYFA_SONUC_BASARILI = 2;

// test amaçlı
// const responseOnayKodu = () => ({success:true,yontem:'sms', onaySuresi: 120,
//     message: "Lütfen 5321300101 numaralı cep telefonunuza gönderilen onay kodunu giriniz"});

export default function () {

    const [sayfa, setSayfa] = useState(SAYFA_KULLANICI);
    const [response, setResponse] = useState({});

    const kullaniciDogrulandi = useCallback((res) => {
        setResponse(res);
        setSayfa(SAYFA_SONUC_BASARILI);
    }, [])

    if (sayfa === SAYFA_KULLANICI)
        return <SayfaKullaniciDogrula dogrulandi={kullaniciDogrulandi}/>;

    if (sayfa === SAYFA_SONUC_BASARILI)
        return <SayfaSonuc>
            <Alert type="success"
                   message={response.message}
                   iconClass="fa fa-2x fa-check-circle"  />
        </SayfaSonuc>;

    return null;
}
